import { Box, Typography } from '@mui/material';
import reviewStarsIcon from '../../../assets/svg/main/review_stars.svg';
import { REVIEWS } from '../config';

function Reviews() {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        flexDirection: 'column',
      }}
    >
      {REVIEWS.map((review, index) => (
        <Box
          key={index}
          sx={{
            border: '1px solid rgba(35, 38, 49, 0.10)',
            borderRadius: '20px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                userSelect: 'none',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Avenir Next',
                  fontWeight: 600,
                  fontSize: '16px',
                  lineHeight: '20px',
                  color: '#232631',
                  userSelect: 'none',
                  marginBottom: '5px',
                }}
              >
                {review.name}
              </Typography>
              <img draggable={false} src={reviewStarsIcon} alt="stars"></img>
            </Box>
            <Box
              sx={{
                borderRadius: '50%',
                overflow: 'hidden',
                width: '52px',
                height: '52px',
                backgroundSize: 'contain',
                backgroundImage: `url(${review.image})`,
              }}
            ></Box>
          </Box>
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: 'normal',
              userSelect: 'none',
              color: '#232631',
            }}
          >
            {review.text}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default Reviews;
